import { supabase } from "@/services/supabase/createClient";

export const goToBillingPortal = async () => {
  const { data, error } = await supabase.functions.invoke("bff/api/payments/billing-portal/session", {
    method: "GET",
  });

  if (data) window.open(data?.session.url, "_self");

  return { error };
};
